import { motion } from "framer-motion";

/**
 * PhoneMockup — a stylised iPhone frame containing rich content.
 * Pass either `image` (bg image url) or `children` (custom screen).
 */
export default function PhoneMockup({
  children,
  image,
  className = "",
  rotate = 0,
  delay = 0,
  "data-testid": testId,
}) {
  return (
    <motion.div
      data-testid={testId}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      style={{ transform: `rotate(${rotate}deg)` }}
      className={`relative mx-auto ${className}`}
    >
      <div
        className="relative w-[260px] sm:w-[280px] rounded-[42px] bg-neutral-900 p-[10px] shadow-[0_30px_70px_-20px_rgba(0,0,0,0.35)]"
        style={{ aspectRatio: "9 / 19.5" }}
      >
        {/* Side buttons */}
        <span className="absolute -left-[3px] top-24 h-14 w-[3px] rounded-l-md bg-neutral-800" />
        <span className="absolute -left-[3px] top-44 h-10 w-[3px] rounded-l-md bg-neutral-800" />
        <span className="absolute -right-[3px] top-32 h-20 w-[3px] rounded-r-md bg-neutral-800" />

        <div
          className="relative h-full w-full overflow-hidden rounded-[32px] bg-neutral-950"
          style={
            image
              ? {
                  backgroundImage: `url(${image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }
              : undefined
          }
        >
          {/* Dynamic Island */}
          <div className="absolute left-1/2 top-2 z-20 h-6 w-24 -translate-x-1/2 rounded-full bg-black" />
          {children}
        </div>
      </div>
    </motion.div>
  );
}
